import { render, staticRenderFns } from "./WeekdayDateItem.vue?vue&type=template&id=0827a1fe"
import script from "./WeekdayDateItem.vue?vue&type=script&lang=js"
export * from "./WeekdayDateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports